<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
        <h3 class="font-weight-bold">Revenue Report</h3>
        <div>
                    <span class="mr-2">
                        <sidebar-filter-button>
                            <v-layout row wrap class="ml-2 mr-2">
                                <v-flex xs12 class="mb-4">
                                 <v-text-field
                                     class="hidden-sm-and-down"
                                     outlined
                                     hide-details
                                     placeholder="Search by typing here..."
                                     prepend-inner-icon="search"
                                     v-model="filters.query"
                                     @keypress.enter="fetchFiltersData"
                                 />
                                </v-flex>
                              <v-flex xs12 class="mb-4">
                                 <v-text-field
                                     class="hidden-sm-and-down"
                                     outlined
                                     hide-details
                                     placeholder="Search by voucher/invoice number"
                                     prepend-inner-icon="search"
                                     v-model="filters.voucher_invoice_number"
                                     @keypress.enter="fetchFiltersData"
                                 />
                                </v-flex>
                                <v-flex xs12 class="mb-4">
                                   <custom-date-range-picker
                                       @change="fetchFiltersData"
                                       v-model="filters.date_range"
                                       :outlined="true"
                                   />
                                </v-flex>
                                <v-flex xs12 class="mb-4">
                                    <v-autocomplete
                                        :items="countries"
                                        chips
                                        clearable
                                        deletable-chips
                                        flat
                                        hide-details
                                        item-text="country_name"
                                        item-value="id"
                                        label="Country"
                                        multiple
                                        prepend-inner-icon="filter_list"
                                        outlined
                                        solo
                                        v-model="filters.country"
                                        @change="fetchFiltersData"
                                    />
                                </v-flex>
                                <v-flex xs12 class="mb-4">
                                      <v-autocomplete
                                          :items="visaTypes"
                                          chips
                                          clearable
                                          deletable-chips
                                          flat
                                          outlined
                                          hide-details
                                          item-text="type"
                                          item-value="id"
                                          label="Visa Type"
                                          multiple
                                          prepend-inner-icon="filter_list"
                                          solo
                                          v-model="filters.visaType"
                                          @change="fetchFiltersData"
                                      />
                                </v-flex>
                              <!--                                <v-flex xs12 class="mb-4">-->
                              <!--                                    <v-autocomplete-->
                              <!--                                        :items="revenueTypes"-->
                              <!--                                        chips-->
                              <!--                                        clearable-->
                              <!--                                        deletable-chips-->
                              <!--                                        flat-->
                              <!--                                        outlined-->
                              <!--                                        hide-details-->
                              <!--                                        item-text="label"-->
                              <!--                                        item-value="value"-->
                              <!--                                        label="Revenue Type"-->
                              <!--                                        multiple-->
                              <!--                                        prepend-inner-icon="filter_list"-->
                              <!--                                        solo-->
                              <!--                                        v-model="filters.revenueType"-->
                              <!--                                        @change="fetchFiltersData"-->
                              <!--                                    />-->
                              <!--                                </v-flex>-->
                                <v-flex xs12 class="mb-4">
                                      <v-autocomplete
                                          :items="offices"
                                          chips
                                          clearable
                                          deletable-chips
                                          flat
                                          outlined
                                          hide-details
                                          item-text="name"
                                          item-value="id"
                                          label="Filter By Office"
                                          multiple
                                          @change="fetchFiltersData"
                                          prepend-inner-icon="filter_list"
                                          solo
                                          v-model="filters.officeId"
                                      />
                                </v-flex>
                                <v-flex xs12 class="mb-4">
                                        <v-select
                                            :items="sources"
                                            @change="fetchFiltersData"
                                            label="Filter By source"
                                            clearable
                                            hide-details
                                            flat
                                            outlined
                                            solo
                                            v-model="filters.source"
                                        />
                                </v-flex>
                            </v-layout>

                        </sidebar-filter-button>
                    </span>
          <export-excel-button :export-data="exportData"
                               v-if="$oauth.checkIfHasPermission(['export revenue-report'])"/>
          <refresh-button :click-function="refreshData"></refresh-button>
        </div>
      </v-flex>
      <v-flex lg12>
        <v-card>
          <v-card-text class="pa-0">
            <v-data-table
                :headers="headers"
                :items="data"
                :loading="loading"
                :options.sync="pagination"
                :footer-props="footerProps"
                class="elevation-0"
                v-if="$oauth.checkIfHasPermission(['read revenue-report'])"
                hide-default-footer
            >

              <template v-slot:item.country="{ item }">
                <td>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                                            <span
                                                v-on="on">{{ item.country_code }}</span>
                    </template>
                    <span>{{ item.country }}</span>
                  </v-tooltip>
                </td>
              </template>

              <template v-slot:item.office_name="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{ item.office_code ? item.office_code.toUpperCase() : '' }}</span>
                  </template>
                  <span>{{ item.office_name }}</span>
                </v-tooltip>
              </template>
              <template v-slot:item.invoice_number="{ item }">
              {{item.voucher_invoice_number ? item.voucher_invoice_number : item.invoice_number ? item.invoice_number : item.track_invoice_number}}
              </template>
              <template v-slot:item.action="{ item }">
                <v-tooltip top v-if="$oauth.checkIfHasPermission('read traveller-history')">
                  <template v-slot:activator="{ on }">
                    <v-btn
                        class="mr-2"
                        color="primary"
                        dark
                        dense
                        fab
                        v-on="on"
                        :href="'/system/travellers-history/view/'+item.traveller"
                        :to="'/system/travellers-history/view/'+item.traveller"
                        x-small>
                      <v-icon small>mdi-account</v-icon>
                    </v-btn>
                  </template>
                  <span>View Traveller</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on }"
                            v-if="item.submission_no && $oauth.checkIfHasPermission('read visa-request')">
                    <v-btn
                        class="mr-2"
                        color="primary"
                        dark
                        dense
                        fab
                        v-on="on"
                        :href="'/system/visa-requests/view/'+item.submission_no"
                        :to="'/system/visa-requests/view/'+item.submission_no"
                        x-small>
                      <v-icon small>mdi-equal-box</v-icon>
                    </v-btn>
                  </template>
                  <span>View Visa</span>
                </v-tooltip>
              </template>
            </v-data-table>
            <issued-visa-footer @nextClick="handleNextClick" @prevClick="handlePrevClick"
                                :disable-next="disableNext"
                                :disable-prev="disablePrev"
                                :perPage="pagination.itemsPerPage"
                                @rowChanged="fetchDataWithRow"
                                @getCount="getCount"
                                :total="total"
                                :items-loading="totalItemsLoading"
                                :showing-of="showingOf"
            />
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {mapActions, mapMutations, mapGetters} from 'vuex';
import CustomDateRangePicker from "../../components/CustomDateRangePicker";
import {commonStoreMixin} from "../../mixins/commonStoreMixin";
import IssuedVisaFooter from "../../components/footer/IssuedVisaFooter";
import ExportExcelButton from "../../components/ExportExcelButton";
import SidebarFilterButton from "../../components/SidebarFilterButton";
import RefreshButton from "@/components/RefreshButton";

export default {
  data() {
    return {
      filterDrawer: true,
      pagination: {
        itemsPerPage: 25,
        sortBy: ["created_at"],
        sortDesc: ["true"]
      },
      sources: ['Malanika', 'Manual', 'Online'],
      revenueTypes: [
        {
          label: "Visa Fee",
          value: "1"
        },
        {
          label: "Late Fine",
          value: "13"
        },
        {
          label: "Overstay Fine",
          value: "14"
        }
      ],
      title: "Revenue Report",
      headers: [
        {
          text: "S.N.",
          value: "s_no",
          sortable: false
        },
        {
          text: "Full name",
          value: "full_name",
          sortable: false
        },
        {
          text: "Country",
          value: "country",
          sortable: false
        },
        {
          text: "Voucher / Invoice Number",
          value: "invoice_number",
          sortable: false
        },
        {
          text: "Amount(USD)",
          value: "amount",
          sortable: false
        },
        {
          text: "Amount(NPR)",
          value: "amount_npr",
          sortable: false
        },
        {
          text: "Office",
          value: "office_name",
          sortable: false
        },
        {
          text: "Source",
          value: "source",
          sortable: false
        },
        {
          text: "Visa Type",
          value: "visa_type",
          sortable: false
        },
        {
          text: "Time",
          value: "created_at",
          sortable: false
        },
        {
          text: "Action",
          value: "action",
          sortable: false
        }
      ],
      routeParams: null
    };
  },
  components: {RefreshButton, SidebarFilterButton, CustomDateRangePicker, IssuedVisaFooter, ExportExcelButton},
  mixins: [commonStoreMixin],
  computed: {
    ...mapGetters({
      loading: "RevenueReport/reportLoading",
      visaTypes: "VisaTypeList/all",
      countries: "CountryList/all",
      offices: "OfficeList/offices",
    }),
  },
  methods: {

    ...mapActions({
      fetchCountries: "CountryList/fetchAllCountries",
      getOffices: "OfficeList/fetchData",
    }),
    view(item) {
      this.$router.push({
        name: "ViewVisaRequest",
        params: {id: item.id.toString()}
      });
    },
    refreshData(){
      this.fetchData();
    },
  },
  mounted() {
    this.stateName = 'RevenueReport';

    this.commonState = this.$store.state.RevenueReport;
    this.fetchCountries();

    let params = this.$route.params;
    if (params.fromRoute) {
      this.filters.source = params.source;
      this.filters.date_range = {"start": params.start_date, "end": params.end_date}
    }


    if (this.$store.state.VisaTypeList.all.length === 2) {
      this.$store.dispatch('VisaTypeList/fetchAll');
    }
    // this.fetchData()
    if (this.$store.state.OfficeList.offices.length === 0) {
      this.getOffices();
    }
    const query = this.$route.query;
    if (query.start_date || query.country || query.visa_type) {
      if (query.start_date) {
        this.filters.date_range = {
          start: query.start_date,
          end: query.end_date || query.start_date,
        };
      }
      if (query.country) {
        this.filters.country = Array.isArray(query.country)
            ? query.country.map(Number)
            : [Number(query.country)];
      }
      if (query.visa_type) {
        this.filters.visaType = Array.isArray(query.visa_type)
            ? query.visa_type.map(Number)
            : [Number(query.visa_type)];
      }
      if (query.offices) {
        this.filters.officeId = Array.isArray(query.offices)
            ? query.offices.map(Number)
            : [Number(query.offices)];
      }
    }
  },
  watch: {
    '$route.params': function (newVal,oldVal){
      let params = newVal
      console.log(newVal)
      if (params.fromRoute) {
        let editedFilter = {};
        editedFilter.source = params.source;
        editedFilter.date_range = {"start": params.start_date, "end": params.end_date}
        this.setFilters(editedFilter)
        this.fetchData()
      }
    }
  }
};
</script>
